export default __webpack_public_path__ + "d64e6e7084d3bfbeaf6481b906c91b9a.png";